module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Darren Shan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Darren Shan")]), _vm._v(" is the bestselling author of the young adult series Cirque Du Freak, The Demonata, and the Saga of Larten Crepsley series, as well as the stand-alone book "), _c('I', [_vm._v("The Thin Executioner")]), _vm._v(". His books have sold over 25 million copies worldwide. Shan divides his time between his homes in Ireland and London.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VzH2or/images/Bec-cover.jpg?1734367810031",
      "alt": "This image is the cover for the book Bec, The Demonata"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bec, The Demonata\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An orphan girl in ancient Ireland must face fearsome demons—and her own terrifying fate—as this epic YA horror series continues.")])]), _c('p', [_vm._v("As demonic Fomorii ravage their land, Bec and a band of warrior companions leave their devastated refuge to answer a plea for help. An orphaned priestess-in-training, Bec hopes the journey will help her solve the mysteries of her birth. But learning the truth can be even more costly than fighting demons…")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0